import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoSolicitudGastosOrtopedia = {
  status: number | null;
  statusText: string | null;
};

const getBackendMessage = (err: any) => {
  const responseData = err?.response?.data;

  return (
    (typeof responseData === "string" ? responseData : null) ||
    responseData?.response ||
    responseData?.message ||
    err?.response?.statusText ||
    err?.message ||
    "Error"
  );
};

const useGetInfoSolicitudGastosOrtopedia = () => {
  const [loadingGetInfoSolicitudGastosOrtopedia, setLoadingGetInfoSolicitudGastosOrtopedia] = useState(false);
  const [successGetInfoSolicitudGastosOrtopedia, setSuccessGetInfoSolicitudGastosOrtopedia] = useState(false);
  const [errorGetInfoSolicitudGastosOrtopedia, setErrorGetInfoSolicitudGastosOrtopedia] = useState<any>(null);
  const [dataGetInfoSolicitudGastosOrtopedia, setDataGetInfoSolicitudGastosOrtopedia] = useState<any>(null);
  const [statusGetInfoSolicitudGastosOrtopedia, setStatusGetInfoSolicitudGastosOrtopedia] =
    useState<StatusGetInfoSolicitudGastosOrtopedia>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoSolicitudGastosOrtopedia = async (
    userId: string,
    expedienteId: string | number | null = null,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoSolicitudGastosOrtopedia(true);
    setSuccessGetInfoSolicitudGastosOrtopedia(false);
    setErrorGetInfoSolicitudGastosOrtopedia(null);

    try {
      void expedienteId;
      const res = await apiRecord.getInfoSolicitudGastosContingenciaProfesionalOrtopedia(userId);

      setStatusGetInfoSolicitudGastosOrtopedia({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoSolicitudGastosOrtopedia(true);
      setDataGetInfoSolicitudGastosOrtopedia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      const backendMessage = getBackendMessage(err);

      setStatusGetInfoSolicitudGastosOrtopedia({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoSolicitudGastosOrtopedia(err);
      console.error("Error en getInfoSolicitudGastosOrtopedia:", err);

      throw err;
    } finally {
      setLoadingGetInfoSolicitudGastosOrtopedia(false);
    }
  };

  return {
    getInfoSolicitudGastosOrtopedia,
    loadingGetInfoSolicitudGastosOrtopedia,
    successGetInfoSolicitudGastosOrtopedia,
    errorGetInfoSolicitudGastosOrtopedia,
    dataGetInfoSolicitudGastosOrtopedia,
    statusGetInfoSolicitudGastosOrtopedia
  };
};

export default useGetInfoSolicitudGastosOrtopedia;
